import React from 'react'
import SimpleTable from 'components/Tables/SimpleTable'

export default ({ node }) => (
  <div>
    <SimpleTable>
      <div>
        <div>Tag:</div>
        <div>{node.extras.tag}</div>
      </div>
    </SimpleTable>
  </div>
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/ContactTagApplied/ContactTagAppliedDisplay.jsx